import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BlankLayout } from '@/layout';
import { init } from '@/model/global/actions';
import { makeSelectInitialized } from '@/model/global/selectors';

const selectInitialization = makeSelectInitialized();

const withGlobalInitialization = (Component: React.FC) => (props: { [k in string]: unknown }): JSX.Element => {
  const dispatch = useDispatch();
  const initialized = useSelector(selectInitialization);
  useEffect(() => {
    if (!initialized) {
      init()(dispatch);
    }
  }, [initialized, dispatch]);
  return initialized ? <Component {...props} /> : <BlankLayout />;
};

export default withGlobalInitialization;
